import { forwardRef } from 'react';

import { Button } from '../../../../atoms';
import { Filter3Icon } from '../../../../icons';

import { SelectedFiltersCountBadge } from './SelectedFiltersCountBadge';

export type FiltersDrawerTriggerProps = Omit<
  React.ComponentProps<typeof Button>,
  'id' | 'aria-label' | 'children'
>;

export const FiltersDrawerTrigger = forwardRef<
  HTMLButtonElement,
  FiltersDrawerTriggerProps
>((props, ref) => {
  return (
    <div className="relative inline-flex">
      <Button
        aria-label="Open filters"
        id="open-filters-button"
        size="icon"
        variant="outline"
        {...props}
        ref={ref}
      >
        <Filter3Icon />
      </Button>
      <SelectedFiltersCountBadge />
    </div>
  );
});

FiltersDrawerTrigger.displayName = 'FiltersDrawerTrigger';
